import { useState } from 'react'
import { BaseGridLayout, BaseScatola, BaseTextInput, BaseFeedbackConIcona } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { DATICONDUCENTE_VERBALE_DECURTAZIONE } from 'configuration/datiConducente'
import Sezione from 'components/ui/Sezione'
import RiassuntoSituazioneDatiConducente from 'components/ui/datiConducente/RiassuntoSituazioneDatiConducente'
import MessaggioEvidenziato from 'components/ui/MessaggioEvidenziato'
import Titoletto from 'components/ui/Titoletto'
import Testo from 'components/ui/Testo'
import FormPatente, { FormPatenteProvider, RiassuntoPatente } from 'components/form/FormPatente'
import SezioneForm from 'components/form/SezioneForm'
import FormAnagrafica, { FormAnagraficaProvider, RiassuntoAnagrafica } from 'components/form/FormAnagrafica'
import LineaSeparatrice from 'components/ui/LineaSeparatrice'
import useSchermoStretto from 'hook/useSchermoStretto'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'
import { CFG_SITUAZIONI_DATI_CONDUCENTE, SITUAZIONE_DATI_CONDUCENTE, calcolaDichiaranteDatiConducente, trasformaDichiarazionePerSalvataggio } from '../utilDatiConducente'

const CFG = DATICONDUCENTE_VERBALE_DECURTAZIONE

const NOMI = {
  DICHIARANTE_IN_QUALITA_DI: 'dichiaranteInQualitaDi',
  DICHIARANTE: 'dichiarante',
  CONDUCENTE: 'conducente',
}

export default function DecurtazionePuntiInserisciDati(props) {
  const {
    val, txt,
    chiaveVerbale,
    situazione,
    datiInseriti,
    setDatiInseriti,
    setModuloBin,
    isAzienda,
    anagrafica
  } = props

  return (
    <>
      <Sezione
        titolo={val(CFG.INSERISCI_DATI_TITOLO)}
        sottotitolo={val(CFG.INSERISCI_DATI_SOTTOTITOLO)}
      >
        <BaseGridLayout vertical sx={{ mt: 0 }}>
          <BaseScatola outlined>
            <RiassuntoSituazioneDatiConducente txt={txt} situazione={situazione} />
          </BaseScatola>

          {situazione === SITUAZIONE_DATI_CONDUCENTE.CASO_B &&
            <MessaggioEvidenziato error titolo={val(CFG.INSERISCI_DATI_AVVISO_SPESE_TITOLO)}>
              {txt(CFG.INSERISCI_DATI_AVVISO_SPESE_DESCR)}
            </MessaggioEvidenziato>
          }

          <BaseScatola outlined>
            <FormDichiarazioneDati
              txt={txt}
              chiaveVerbale={chiaveVerbale}
              situazione={situazione}
              datiInseriti={datiInseriti}
              setDatiInseriti={setDatiInseriti}
              setModuloBin={setModuloBin}
              isAzienda={isAzienda}
              anagrafica={anagrafica}
            />
          </BaseScatola>
        </BaseGridLayout>
      </Sezione>

      <MessaggioEvidenziato error titolo={val(CFG.INSERISCI_DATI_AVVISO_PROCEDURA_INCOMPLETA_TITOLO)} sx={{ mt: 4 }}>
        {txt(CFG.INSERISCI_DATI_AVVISO_PROCEDURA_INCOMPLETA_DESCR)}
      </MessaggioEvidenziato>
    </>
  )
}



function FormDichiarazioneDati(props) {
  const {
    txt,
    chiaveVerbale,
    situazione,
    datiInseriti,
    setDatiInseriti,
    setModuloBin,
    isAzienda,
    anagrafica,
  } = props

  const defaultValues = {
    [NOMI.DICHIARANTE_IN_QUALITA_DI]: '',
    [NOMI.DICHIARANTE]: calcolaDichiaranteDatiConducente(situazione, anagrafica) ?? FormAnagrafica.DEFAULT_VALUES,
    [NOMI.CONDUCENTE]: { ...FormAnagrafica.DEFAULT_VALUES, patente: FormPatente.DEFAULT_VALUES },
  }

  const schermoStretto = useSchermoStretto()

  const { cfgDichiaraFrase1, cfgDichiaraFrase2 } = CFG_SITUAZIONI_DATI_CONDUCENTE[situazione]
  const casoB = situazione === SITUAZIONE_DATI_CONDUCENTE.CASO_B

  const [messaggioErrore, setMessaggioErrore] = useState(false)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  async function inviaDati(dati) {
    const { ok, data } = await inviaOperazione(OPERAZIONI.INVIO_DATI_PATENTE, {
      chiave: chiaveVerbale,
      dichiarazione: trasformaDichiarazionePerSalvataggio(situazione, dati),
    })
    if (ok) {
      const { esito, messaggio, bin } = data
      if (esito) {
        setDatiInseriti(dati)
        setModuloBin(bin)
        return { ok: true }
      }
      setMessaggioErrore(messaggio)
    }
    return { ok: false }
  }

  return (
    <FormAnagraficaProvider>
      <FormPatenteProvider>
        <SezioneForm
          titolo={txt(CFG.INSERISCI_DATI_DICHIARAZIONE)}
          defaultValues={datiInseriti ?? defaultValues}
          onSubmit={inviaDati}
          larghezzaInputs={schermoStretto ? 'fullWidth' : 20}
          inAttesa={inAttesaDelServer}
          Riassunto={valori =>
            <BaseGridLayout {...(schermoStretto && { propsGridItem: { sx: { width: '100%' } } })}>
              <BaseScatola outlined sx={{ width: schermoStretto ? '100%' : 400, }}>
                <Titoletto variant='h6'>{txt(CFG.INSERISCI_DATI_DATI_DICHIARANTE)}</Titoletto>
                <RiassuntoAnagrafica anagrafica={valori.dichiarante} />
              </BaseScatola>

              <BaseScatola outlined sx={{ width: schermoStretto ? '100%' : 400, }}>
                <Titoletto variant='h6'>{txt(CFG.INSERISCI_DATI_DATI_CONDUCENTE)}</Titoletto>
                {casoB
                  ? <RiassuntoAnagrafica anagrafica={valori.conducente} />
                  : <RiassuntoPatente patente={valori.conducente.patente} />
                }
              </BaseScatola>
            </BaseGridLayout>
          }
        >
          <BaseGridLayout vertical>
            <BaseScatola outlined>
              <FormAnagrafica
                prefissoNomi={NOMI.DICHIARANTE}
                titolo={txt(CFG.INSERISCI_DATI_DATI_TITOLO)}
              />
            </BaseScatola>

            {isAzienda &&
              <BaseScatola outlined>
                <Titoletto variant='h6'>{txt(CFG.INSERISCI_DATI_IN_QUALITA_DI_TITOLO)}</Titoletto>
                <BaseTextInput
                  label={txt(CFG.INSERISCI_DATI_IN_QUALITA_DI_RUOLO)}
                  name={NOMI.DICHIARANTE_IN_QUALITA_DI}
                  required
                />
              </BaseScatola>
            }

            <BaseScatola outlined>
              <Titoletto variant='h6'>{txt(CFG.INSERISCI_DATI_DICHIARA_TITOLO)}</Titoletto>
              <Testo sx={{ ...(casoB && { color: '#CC7A00', fontWeight: 'bold' }) }}>{txt(cfgDichiaraFrase1)}</Testo>
              <LineaSeparatrice />
              <Testo sx={{ mb: 2 }}>{txt(cfgDichiaraFrase2)}</Testo>
              {casoB
                ? <FormAnagrafica prefissoNomi={NOMI.CONDUCENTE} />
                : <FormPatente prefissoNomi={`${NOMI.CONDUCENTE}.patente`} />
              }
            </BaseScatola>
          </BaseGridLayout>

          {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}
          {ScatolaMessaggi}
        </SezioneForm>
      </FormPatenteProvider>
    </FormAnagraficaProvider>
  )
}